module.exports = __webpack_public_path__ + "img/page3bg.81a5f3c4.png";